export default class DeclaracaoConteudoItensModel {
    descricao: string = null;
    quantidade: string = null;
    peso: string = null;
}
